import { memo } from 'react';
import ExchangesSelector from './ChainExchangeSelector';
import TabsSelector from './TabsSelector';
import TickersModalSearch from './TickersModalSearch';
import TickersModalTable from './Table';
import Resizer from '../../Resizer';

import './styles.scss';

const LS_TICKERS_HEIGHT = 'kattana-simple.tickers_modal_height';
const MODAL_TOP_GAP = 300;

const getSavedHeight = () => {
  const value = localStorage.getItem(LS_TICKERS_HEIGHT);
  if (value) {
    return Math.max(MODAL_TOP_GAP, Number(value));
  } else {
    return '90vh';
  }
};

const TickersModal = () => {
  const height = getSavedHeight();

  return (
    <div className='tickers__modal' style={{ height }}>
      <div className='tickers__panel'>
        <TickersModalSearch />
        <div className='tickers__panel__table_container'>
          <TabsSelector />
          <ExchangesSelector />
          <div className='tickers__panel__table'>
            <TickersModalTable />
          </div>
        </div>
      </div>
      <Resizer
        targetClass='tickers__modal'
        storageKey={LS_TICKERS_HEIGHT}
        topGap={MODAL_TOP_GAP}
        styleProperty='height'
      />
    </div>
  );
};

export default memo(TickersModal);
